import { render } from "./PrivateView.vue?vue&type=template&id=787a3024&scoped=true"
import script from "./PrivateView.vue?vue&type=script&lang=js"
export * from "./PrivateView.vue?vue&type=script&lang=js"

import "./PrivateView.vue?vue&type=style&index=0&id=787a3024&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-787a3024"]])

export default __exports__